import { ChevronLeftIcon, ChevronRightIcon, StarIcon } from '@heroicons/react/20/solid'
import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Navigation } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'
import { useMediaQuery } from 'usehooks-ts'

import {
	BlendIcon,
	CalendarIcon,
	ClockIcon,
	CrownIcon,
	FlashIcon,
	InstagramIcon,
	LayerIcon,
	LocationIcon,
	LogoIcon,
	MailIcon,
	MaskIcon,
	PhoneIcon,
	ProfilePhotoImage,
	ShapesIcon,
} from '@/assets/icons'
import Header from '@/components/header'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import Footer from '@/components/footer'
import { useAppSelector } from '@/hooks'
import 'swiper/css'
import 'swiper/css/pagination'

const features = [
	{
		id: 1,
		icon: MaskIcon,
		title: 'Nachhaltig',
		description: 'Lebenszyklus deiner Sachen verlängern und Ressourcen und Umwelt schonen',
	},
	{
		id: 2,
		icon: LayerIcon,
		title: 'Transparent',
		description: 'Verfolge deine Verkäufe und Umsätze in Echtzeit',
	},

	{
		id: 3,
		icon: ShapesIcon,
		title: 'Einfach & Praktisch',
		description: 'Artikel eintragen, etikettieren und aufhängen',
	},
]

const pricing = [
	{
		id: 1,
		icon: BlendIcon,
		title: '1 Woche',
		pricing: 25,
		provision: 20,
	},
	{
		id: 2,
		icon: FlashIcon,
		title: '2 Wochen',
		pricing: 40,
		provision: 20,
	},
	{
		id: 3,
		icon: CrownIcon,
		title: '3 Wochen',
		pricing: 60,
		provision: 20,
	},
	{
		id: 4,
		icon: BlendIcon,
		title: '4 Wochen',
		pricing: 70,
		provision: 20,
	},
	{
		id: 5,
		icon: BlendIcon,
		title: '4 Wochen',
		pricing: 0,
		provision: 45,
	},
]

const socials = [
	{
		id: 1,
		icon: LocationIcon,
		title: 'Kieler Str. 113<br /> 24119 Kronshagen',
	},
	{
		id: 2,
		icon: PhoneIcon,
		title: '0431 - 59674213',
	},
	{
		id: 3,
		icon: MailIcon,
		title:
			'<span style="display:flex;flex-direction:column;gap:4px"><span style="display:flex;gap:6px;flex-wrap:wrap"><span style="color:hsl(var(--muted-foreground));font-weight:500">Allgemeine Anfragen:</span><span>support@minmini.de</span></span><span style="display:flex;gap:6px;flex-wrap:wrap"><span style="color:hsl(var(--muted-foreground));font-weight:500">Geschäftliche Anfragen:</span><span>info@minmini.de</span></span></span>',
	},
	{
		id: 4,
		icon: ClockIcon,
		title:
			'<span style="display:flex;flex-direction:column;gap:2px"><span style="display:flex;gap:8px"><span style="width:16ch;flex-shrink:0">Montag - Freitag:</span><span style="display:flex;flex-direction:column"><span>10:00 - 13:00 Uhr</span><span>14:00 - 18:00 Uhr</span></span></span><span style="display:flex;gap:8px"><span style="width:16ch;flex-shrink:0">Samstag:</span><span>10:00 - 15:00 Uhr</span></span></span>',
	},
	{
		id: 5,
		icon: InstagramIcon,
		title: 'Nichts mehr verpassen - folge uns auf Instagram',
		link: 'https://www.instagram.com/minmini.kidsstore',
	},
]

const reviews = [
	{
		id: 1,
		image: ProfilePhotoImage,
		name: 'Yvonne S.',
		date: '1. März 2025',
		review:
			'Eine tolles Konzept. Man wird immer sehr freundlich empfangen und kann sich bei Fragen jederzeit ans Personal wenden. Der Laden ist immer aufgeräumt und lädt zum Verweilen und stöbern ein. schon oft haben wir tolle Schnäppchen für unser Baby machen können.besinders in der Schwangerschaft, war minmini ein toller Anlaufpunkt für die Erstausstattung. Demnächst haben wir ein Regal zur Miete, wir sind schon sehr gespannt. Die Buchung lief reibungslos.',
		stars: 5,
	},
	{
		id: 2,
		image: ProfilePhotoImage,
		name: 'Nina Wolf',
		date: '29. Dezember 2024',
		review:
			'Ich bin sehr zufrieden mit minmini ein super Konzept wurde da entwickelt. Werde nächstes Jahr wieder regale mieten. ☺️',
		stars: 5,
	},
	{
		id: 3,
		image: ProfilePhotoImage,
		name: 'tina s',
		date: '29. April 2024',
		review:
			'Wunderschöner Laden mit einem tollen Konzept. Entspanntes Stöbern garantiert. Auch als Regal-Mieterin fühlt man sich sehr wohl und willkommen. Und streikte mal die Technik wurde bisher IMMER eine sehr gute Lösung für beide Seiten gefunden. Auch eine längere Anfahrt lohnt sich bei diesen großartigen Laden auf jeden Fall. DANKE dass wir bei euch sein dürfen.',
		stars: 5,
	},
	{
		id: 4,
		image: ProfilePhotoImage,
		name: 'Prinzessin Gute Laune',
		date: '29. September 2024',
		review:
			'Minmini ist so ein schöner freundlicher Laden super schöne Sachen zu günstigen Preisen. Die Mitarbeiter sind alle sehr freundlich. Einfach perfekt ❤️',
		stars: 5,
	},
	{
		id: 5,
		image: ProfilePhotoImage,
		name: 'Ana Kipp',
		date: '29. April 2024',
		review:
			'Ganz wunderbarer Laden nach skandinavischem Konzept. Hier findet man wirklich tolle ausgesuchte Kinderkleidung, Schuhe, Tragen, Bücher, Spielzeug, etc. für jeden Geldbeutel. Auch eine etwas weitere Anreise lohnt sich, es gibt Parkplätze direkt vor der Tür. Das Team ist super nett und hilfsbereit und auch als Verkäufer fühlt man sich 100% Willkommen und wird jederzeit! mit Rat und Tat unterstützt. Ich komme sehr gerne wieder. Als Kundin und Verkäuferin.',
		stars: 5,
	},
	{
		id: 6,
		image: ProfilePhotoImage,
		name: 'Annika',
		date: '29. April 2024',
		review:
			'Ein Seconhand Laden für Kinderkleidung wie ich ihn von unseren skandinavischen Nachbarn kenne. Endlich auch hier! Clean und gemütlich eingerichtet, jeder verkauft seine Sachen in einem Fach. Man kann ein Schnäppchen machen',
		stars: 4,
	},
]

export const Home = () => {
	const isSmallScreen = useMediaQuery('(max-width: 64rem)')
	const navigate = useNavigate()
	const auth = useAppSelector(state => state.auth)

	const shouldRedirect = sessionStorage.getItem('shouldRedirect')

	const bookingRef = useRef<HTMLDivElement>(null)
	const contactRef = useRef<HTMLDivElement>(null)
	const prevRef = useRef<HTMLDivElement>(null)
	const nextRef = useRef<HTMLDivElement>(null)

	const [isPrevDisabled, setIsPrevDisabled] = useState(true)
	const [isNextDisabled, setIsNextDisabled] = useState(true)

	useEffect(() => {
		if (auth?.type === 'admin' && shouldRedirect !== 'false') {
			navigate('/admin-panel', { replace: true })
		}
	}, [auth, shouldRedirect])

	return (
		<div>
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="startseite" />
				<div className="flex flex-col gap-6 max-w-11/12 lg:max-w-1/2 mx-auto justify-center items-center">
					<LogoIcon className="h-[200px] sm:h-[300px] md:h-[350px] lg:h-[350px] xl:h-[400px] 2xl:h-[500px] w-auto" />

					<h1 className="text-secondary font-extrabold text-xl lg:text-[30px] max-lg:leading-8 text-center">
						Miete dein eigenes Regal, schaffe Platz und gib deinen Schätzen ein neues Zuhause!
					</h1>
				</div>
				<p className="mt-3 lg:mt-6 max-lg:text-sm max-lg:max-w-3/4 max-lg:mx-auto font-medium text-secondary text-center">
					(Ver)kaufe nachhaltig und verdiene dabei!
				</p>
				<div className="flex items-center justify-center mt-8 gap-[18px]">
					<Button
						onClick={() => bookingRef.current?.scrollIntoView({ behavior: 'smooth' })}
						size={isSmallScreen ? 'sm' : 'default'}>
						<CalendarIcon className="mr-[1.5px] text-white" />
						Regal Mieten
					</Button>
					<Button
						onClick={() => contactRef.current?.scrollIntoView({ behavior: 'smooth' })}
						size={isSmallScreen ? 'sm' : 'default'}
						variant="outline">
						Kontakt
					</Button>
				</div>
				<div className="mt-16 lg:mt-[140px] px-5 flex flex-col gap-4 lg:gap-10">
					<h2 className="text-secondary lg:text-2xl 2xl:text-[32px] font-extrabold text-center">
						Warum minmini?
					</h2>
					<div className="flex max-lg:flex-col items-center justify-center gap-3 lg:gap-5">
						{features.map(feature => (
							<FeatureCard
								key={feature.id}
								icon={feature.icon}
								title={feature.title}
								description={feature.description}
							/>
						))}
					</div>
				</div>
				<div ref={bookingRef} className="mt-16 lg:mt-[140px] px-5 flex flex-col gap-4 lg:gap-10">
					<div>
						<h2 className="text-secondary lg:text-2xl 2xl:text-[32px] font-extrabold text-center">
							Buche jetzt dein Verkaufsregal
						</h2>
					</div>
					<div className="flex max-lg:flex-col items-center lg:flex-wrap justify-center gap-5">
						{pricing.map((price, index) => (
							<PricingCard
								key={price.id}
								index={index}
								icon={price.icon}
								title={price.title}
								pricing={price.pricing}
								provision={price.provision}
							/>
						))}
					</div>
				</div>
				<div ref={contactRef} className="mt-16 lg:mt-[140px] px-5 flex flex-col">
					<h2 className="text-secondary lg:text-2xl 2xl:text-[32px] font-extrabold text-center">
						Kontaktiere uns
					</h2>
					<p className="mt-2 max-lg:text-xs max-2xl:text-sm text-center lg:mt-3 text-secondary font-medium">
						Egal ob Fragen, Feedback oder besondere Wünsche – wir helfen dir gerne weiter!
					</p>
					<div className="mt-10 rounded-[20px] flex max-lg:flex-col items-center gap-5 lg:gap-8 bg-[#EFEFEF4D] py-5 max-lg:px-4 lg:py-[47px] lg:pl-10 lg:pr-[29px]">
						<iframe
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2326.419591092771!2d10.0776702!3d54.3318916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b255c7e56edb47%3A0x30c2bd90a916cb7a!2sKieler%20Str.%20113%2C%2024119%20Kronshagen%2C%20Germany!5e0!3m2!1sen!2s!4v1685042099165!5m2!1sen!2s"
							width="100%"
							height="360"
							className="border-0 lg:basis-3/5"
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"></iframe>
						<div className="flex flex-col gap-5 lg:gap-8">
							{socials.map(social =>
								social.link ? (
									<Link
										target="__blank"
										key={social.id}
										to={social.link}
										className="flex items-center gap-3">
										<social.icon className="shrink-0 max-lg:size-5 max-2xl:size-8" />
										<h5
											className="text-secondary text-xs lg:text-sm font-extrabold"
											dangerouslySetInnerHTML={{ __html: social.title }}
										/>
									</Link>
								) : (
									<div key={social.id} className="flex items-center gap-3">
										<social.icon className="shrink-0 max-lg:size-5 max-2xl:size-8" />
										<h5
											className="text-secondary text-xs lg:text-sm font-extrabold"
											dangerouslySetInnerHTML={{ __html: social.title }}
										/>
									</div>
								),
							)}
						</div>
					</div>
				</div>
				<div className="mt-16 lg:mt-[140px] px-5 flex flex-col">
					<h2 className="text-secondary lg:text-[32px] font-extrabold text-center">Das sagt ihr</h2>
					<div className="mt-[19px] lg:mt-8 bg-[#EFEFEF4D] pb-6 lg:pb-10 pt-8 lg:pt-[90px]">
						<div className="relative w-full overflow-hidden">
							<Swiper
								slidesPerView={isSmallScreen ? 1.2 : 3}
								spaceBetween={isSmallScreen ? 12 : 21}
								centeredSlides={isSmallScreen}
								modules={[Navigation]}
								navigation={{
									prevEl: prevRef.current,
									nextEl: nextRef.current,
								}}
								className={cn(isSmallScreen ? 'mobile-swiper-transition' : 'swiper-transition')}
								onBeforeInit={(swiper: SwiperClass) => {
									const params = swiper.params
									const navigation = params.navigation
									// @ts-ignore
									navigation.prevEl = prevRef.current
									// @ts-ignore
									navigation.nextEl = nextRef.current
								}}
								onSlideChange={(swiper: SwiperClass) => {
									setIsPrevDisabled(swiper.isBeginning)
									setIsNextDisabled(swiper.isEnd)
								}}
								onSwiper={(swiper: SwiperClass) => {
									const params = swiper.params
									const navigation = params.navigation
									// @ts-ignore
									navigation.prevEl = prevRef.current
									// @ts-ignore
									navigation.nextEl = nextRef.current
									swiper.navigation.init()
									swiper.navigation.update()
									setIsPrevDisabled(swiper.isBeginning)
									setIsNextDisabled(swiper.isEnd)
								}}>
								{reviews.map(review => (
									<SwiperSlide className="sm:!h-auto" key={review.id}>
										<ReviewCard
											name={review.name}
											image={review.image}
											stars={review.stars}
											review={review.review}
											date={review.date}
										/>
									</SwiperSlide>
								))}
							</Swiper>
						</div>
						<div className="mt-16 w-full flex items-center gap-5 lg:gap-8 justify-center">
							<div
								ref={prevRef}
								className={cn(
									'size-6 lg:size-10 flex items-center justify-center rounded-full border',
									isPrevDisabled
										? 'bg-white cursor-not-allowed text-primary border-primary'
										: 'bg-primary cursor-pointer text-white border-primary',
								)}>
								<ChevronLeftIcon className="shrink-0 size-2.5 lg:size-4" />
							</div>
							<div
								ref={nextRef}
								className={cn(
									'size-6 lg:size-10 flex items-center justify-center rounded-full border',
									isNextDisabled
										? 'bg-white cursor-not-allowed text-primary border-primary'
										: 'bg-primary cursor-pointer text-white border-primary',
								)}>
								<ChevronRightIcon className="shrink-0 size-2.5 lg:size-4" />
							</div>
						</div>
					</div>
				</div>
				<div className="mt-16 lg:mt-[192px] bg-[#E6E6E6] w-full h-px" />
				<Footer />
			</div>
		</div>
	)
}

interface FeatureCardProps {
	icon: React.ElementType
	title: string
	description: string
}

const FeatureCard = ({ icon: Icon, title, description }: FeatureCardProps) => {
	return (
		<div className="rounded-[16px] lg:rounded-[20px] flex-1 bg-[#EFEFEF4D] py-[13px] px-2.5 lg:py-4 lg:px-4 2xl:py-8 2xl:px-[26px] flex items-center gap-1 lg:gap-2">
			<Icon className="size-12 lg:size-14 2xl:size-[94px] shrink-0" />
			<div className="flex flex-col gap-1 lg:gap-2">
				<h3 className="text-sm lg:text-lg 2xl:text-2xl font-extrabold text-secondary">{title}</h3>
				<p className="text-secondary max-lg:text-xs max-2xl:text-sm font-medium">{description}</p>
			</div>
		</div>
	)
}

interface PricingCardProps {
	icon: React.ElementType
	index: number
	title: string
	pricing: number
	provision: number
}

const PricingCard = ({ icon: Icon, index, title, pricing, provision }: PricingCardProps) => {
	const isSmallScreen = useMediaQuery('(max-width: 64rem)')
	const navigate = useNavigate()

	return (
		<div
			className={cn(
				'rounded-[20px] max-lg:flex-1 max-lg:w-full lg:basis-[30%] pt-4 pb-3 px-4 lg:pt-5 lg:pb-4 lg:px-5 2xl:pt-[34px] 2xl:pb-6 2xl:px-8 flex flex-col',
				{
					'bg-[#DCB9B7]': index === 0,
					'bg-[#D3C2B2]': index === 1,
					'bg-[#CAC397]': index === 2,
					'bg-[#C5BFB8]': index === 3,
					'bg-[#D7E0D7]': index === 4,
				},
			)}>
			<div className="flex items-center gap-4">
				<div className="flex items-center shrink-0 justify-center size-8 lg:size-10 2xl:size-12 bg-white rounded-full">
					<Icon className="size-[18px] text-[#EFBC9B] lg:size-8" />
				</div>
				<h3 className="text-secondary lg:text-2xl 2xl:text-[32px] font-extrabold">{title}</h3>
			</div>
			<div
				className={cn('my-5 h-px', index === 1 || index === 4 ? 'bg-[#FFFAF4]' : 'bg-[#FFE4C3]')}
			/>
			<div className="flex items-center gap-5">
				<h2 className="text-secondary text-2xl lg:text-3xl 2xl:text-5xl font-extrabold">
					{pricing}{' '}
					<span className="text-xs lg:text-base 2xl:text-xl -ml-1 lg:-ml-2.5 text-muted-foreground">
						€
					</span>
				</h2>
				<p className="max-2xl:text-sm text-muted-foreground font-medium">
					+ {provision}% Provision
				</p>
			</div>
			<Button
				onClick={() => navigate(`/customer/regal-mieten?paket=${index + 1}`)}
				size={isSmallScreen ? 'sm' : 'default'}
				variant="outline"
				className="mt-[70px] group hover:text-white lg:mt-[80px] 2xl:mt-[102px] bg-white hover:bg-primary">
				<CalendarIcon className="mr-1 group-hover:text-white text-primary" />
				Regal Mieten
			</Button>
		</div>
	)
}

interface ReviewCardProps {
	image: string
	name: string
	date: string
	stars: number
	review: string
}

const ReviewCard = ({ image, name, date, stars, review }: ReviewCardProps) => {
	return (
		<div className="2xl:p-[25px] lg:p-[16px] p-[11px] bg-white rounded-lg lg:rounded-xl 2xl:rounded-2xl h-full flex flex-col gap-2 lg:gap-5">
			<div className="flex items-center justify-between">
				<div className="flex items-center gap-[3px] lg:gap-2">
					<img
						alt=""
						src={image}
						className="size-6 lg:size-8 2xl:size-10 rounded-full bg-gray-50"
					/>
					<div className="flex flex-col gap-px lg:gap-1">
						<h5 className="font-extrabold max-lg:text-sm max-2xl:text-xs text-secondary">{name}</h5>
						<p className="text-muted-foreground text-[10px] lg:text-xs 2xl:text-sm font-medium">
							{date}
						</p>
					</div>
				</div>
				<div className="flex items-center gap-px lg:gap-1">
					{Array.from({ length: 5 }, (_, index) => (
						<StarIcon
							key={index}
							className={cn(
								'size-[11px] lg:size-4 2xl:size-6',
								stars >= index + 1 ? 'text-primary' : 'text-white stroke-black',
							)}
						/>
					))}
				</div>
			</div>
			<p className="text-secondary text-xs lg:text-sm font-medium">{review}</p>
		</div>
	)
}
